import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { CloseIcon } from 'src/assets/icons/CloseIcon';

export const HeaderWrapper = styled('header', { label: 'HeaderWrapper' })`
    align-items: center;
    background-color: ${mainColors.main.secondary};
    color: ${mainColors.default.light};
    display: flex;
    flex: 0 0 50px;
    height: 50px;
    justify-content: space-between;
    padding: 0 16px;
    width: 100%;
`;

export const HeaderTitle = styled('h2', { label: 'HeaderTitle' })`
    font-size: ${fontSize.xxMedium};
    font-weight: ${fontWeight.bold};
`;

export const CrossButton = styled(CloseIcon, { label: 'CrossButton' })`
    fill: currentColor;
    cursor: pointer;
    flex: 0 0 16px;
    width: 16px;
`;

export const ImagesContainer = styled('div', { label: 'ImagesContainer' })`
    align-content: start;
    background-color: ${mainColors.grays.gray100};
    display: grid;
    gap: 12px 24px;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    overflow-y: auto;
    overscroll-behavior-y: contain;
    padding: 16px;
    width: 100%;
    position: relative;
`;
